<template>
    <div class="member-day-slider">
        <!-- <el-table v-loading="isLoading"
            style="width: 100%"
            :data="memberDiscountActivitys">
            <el-table-column
                label="会员日"
                min-width="275">
                <template v-slot="{ row }">
                    <span v-if="row.frequency === 0">
                        每周{{ row.weekdays.map(w => weekDayMap[w]).join('、') }}
                    </span>
                    <date-ellipsis v-if="row.frequency === 1"
                        :dateCache="row.monthdays"/>
                </template>
            </el-table-column>
            <el-table-column
                label="折扣力度"
                min-width="80"
                align="right">
                <template v-slot="{ row }">
                    <span>{{ fixNumPro(row.discount_rate * 10) }}折</span>
                </template>
            </el-table-column>
            <el-table-column/>
            <el-table-column
                label="折扣对象"
                min-width="120">
                <template v-slot="{ row }">
                    <span>{{ discountObjectMap[row.discount_object] }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="折扣商品"
                width="80">
                {{ '所有商品' }}
            </el-table-column>
            <el-table-column
                label="活动状态"
                min-width="80"
                align="right">
                <template v-slot="{ row }">
                    <span>{{ statusMap[row.status] }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="140">
                <template v-slot="{ row }">
                    <button class="text-btn pl-0" @click="updateDiscount">编辑</button>
                    <my-switch v-model="row.isChecked"
                        @change="elSwitchChange(row.isChecked)"/>
                </template>
            </el-table-column>
            <template slot="empty">
                <template v-if="!isLoading">
                    <span class="color-999">暂未设置会员日折扣，</span><button class="text-btn pl-0 pr-0" @click="createDiscount">去设置</button>
                </template>
                <span v-else></span>
            </template>
        </el-table> -->
        <!-- components -->
        <div class="fx">
            <div class="fx card member-background" @click="openMemberDiscountSetting">
                <div class="left">
                    <div class="title">
                        <i></i>
                        <span>会员日折扣</span>
                    </div>
                    <div class="info">
                        <template v-if="memberDiscountActivitys.length > 0">
                            <p>折扣力度：{{fixNumPro(memberDiscountActivitys[0].discount_rate * 10)}}折</p>
                            <p>已引导充值：{{memberDiscountActivitys[0].guided_recharge || 0}}元</p>
                        </template>
                        <template v-else>
                            <p>暂未设置</p>
                        </template>
                    </div>
                </div>
                <div class="right">
                    <el-switch @click.native.stop @change="elSwitchChange(memberDayDiscountSwitch)" v-model="memberDayDiscountSwitch"></el-switch>
                </div>
            </div>
            <div class="fx card points-background" @click="openPointsMagnificationSetting">
                <div class="left">
                    <div class="title">
                        <i></i>
                        <span>多倍积分</span>
                    </div>
                    <div class="info">
                        <template v-if="pointBoosterActivity.multiplier && pointBoosterActivity.multiplier.toString().length > 0">
                            <p>积分倍数：{{pointBoosterActivity.multiplier}}倍</p>
                        </template>
                        <template v-else>
                            <p>暂未设置</p>
                        </template>
                    </div>
                </div>
                <div class="right">
                    <el-switch @click.native.stop :value="true" @change="onPointBoosterSwitchChange(pointBoosterActivitySwitch)" v-model="pointBoosterActivitySwitch"></el-switch>
                </div>
            </div>
        </div>
        <!-- <member-day-slider :mode="mode"
            :visible.sync="isShowMemberSlider"
            :discountActivity="curDiscountActivity"
            :confirmCallback="getMemberDiscountActivity"/> -->
        <points-magnification-setting :activity="pointBoosterActivity" @update="getPointBoosterActivity" ref="pointsMagnificationSetting"></points-magnification-setting>
        <member-discount-setting :mode="mode"
            :visible.sync="isShowMemberSlider"
            :discountActivity="curDiscountActivity"
            :confirmCallback="getMemberDiscountActivity"/>
    </div>
</template>

<script lang='ts'>
import { createComponent, ref, onBeforeMount } from '@vue/composition-api'
import MemberDaySlider from './member_day_slider.vue'
import MySwitch from '../../components/my_switch.vue'
import DateEllipsis from '../../components/date_ellipsis.vue'
import $fetch from '../../../../api'
import { openMessage } from '../../../../utils/system'
import clone from 'lodash/cloneDeep'
import { fixNumPro } from '../../../../utils'
import PointsMagnificationSetting from './points_magnification_setting.vue'
import MemberDiscountSetting from './member_discount_setting.vue'

export interface IMemberDiscountActivity {
    discount_object: number,
    discount_rate: number,
    frequency: number,
    status: number,
    sufficient_balance_required: boolean,
    monthdays: number[],
    weekdays: number[]
}

export type TMemberDiscountActivity = IMemberDiscountActivity[]

export default createComponent({
    setup(props, ctx) {
        const mode = ref<'create' | 'update'>('create')
        const isShowMemberSlider = ref(false)
        const isLoading = ref(false)
        const memberDiscountActivitys = ref<TMemberDiscountActivity>([])
        const pointBoosterActivitySwitch = ref(false)
        const pointBoosterActivity = ref<{
            status: number, // 0 正常 -1 停用
            multiplier: number,
            frequency: number,
            weekdays: number[],
            monthdays: number[]
        }>({})
        const memberDayDiscountSwitch = ref(false)
        const curDiscountActivity = ref<IMemberDiscountActivity>({
            discount_object: 0,
            discount_rate: 0,
            frequency: 0,
            status: 0,
            sufficient_balance_required: false,
            monthdays: [],
            weekdays: []
        })

        const discountObjectMap = {
            0: '有余额会员',
            1: '所有会员'
        }
        const statusMap = {
            '-1': '已停用',
            '0': '进行中'
        }
        const weekDayMap = {
            1: '一',
            2: '二',
            3: '三',
            4: '四',
            5: '五',
            6: '六',
            7: '日'
        }

        onBeforeMount(() => {
            getMemberDiscountActivity()
            getPointBoosterActivity()
        })

        function openMemberDiscountSetting() {
            if (memberDiscountActivitys.value.length == 0) {
                createDiscount()
            } else {
                updateDiscount()
            }
        }

        function createDiscount() {
            mode.value = 'create'
            isShowMemberSlider.value = true
        }

        function updateDiscount() {
            mode.value = 'update'
            isShowMemberSlider.value = true
        }

        async function elSwitchChange(newVal) {
            await changetMemberDiscountStatus(newVal ? 'enable' : 'disable')
            await getMemberDiscountActivity()
        }

        async function changetMemberDiscountStatus(type: 'enable' | 'disable') {
            try {
                switch (type) {
                    case 'enable':
                        await $fetch.post({
                            url: '/activity/enablememberdiscount'
                        })
                        openMessage('success', '启用成功')
                        break
                    case 'disable':
                        await $fetch.post({
                            url: '/activity/disablememberdiscount'
                        })
                        openMessage('success', '停用成功')
                        break
                    default:
                        break
                }
            } catch (e) {
                openMessage('error', e.message || '修改状态失败')
            }
        }

        async function getMemberDiscountActivity() {
            try {
                isLoading.value = true
                const result = await $fetch.post({
                    url: '/activity/getmemberdiscountactivity'
                })
                console.log('会员折扣活动详情', clone(result))
                if (Object.keys(result.activity).length === 0) {
                    return
                }
                Object.defineProperty(result.activity, 'isChecked', {
                    get() {
                        return result.activity.status === 0 ? true : false
                    },
                    set(newVal) {
                        result.activity.status = newVal ? 0 : -1
                    }
                })
                console.log(result.activity.status)
                memberDayDiscountSwitch.value = result.activity.isChecked
                curDiscountActivity.value = result.activity
                memberDiscountActivitys.value = [result.activity]
            } catch (e) {
                openMessage('error', e.message || '获取会员折扣活动详情失败')
            } finally {
                isLoading.value = false
            }
        }

        function getPointBoosterActivity() {
            return $fetch.post({
                url: '/activity/getpointboosteractivity',
                params: {}
            }).then(data => {
                pointBoosterActivity.value = data.activity
                pointBoosterActivitySwitch.value = data.activity.status === 0 ? true : false // -1 关闭 0 开启
            }).catch(e => {
                openMessage("error", e.message || "获取多倍积分设置失败")
            })
        }

        async function onPointBoosterSwitchChange(newVal) {
            await changetPointBoosterActivityStatus(newVal ? 'enable' : 'disable')
            await getPointBoosterActivity()
        }

        async function changetPointBoosterActivityStatus(type: 'enable' | 'disable') {
            try {
                switch (type) {
                    case 'enable':
                        await $fetch.post({
                            url: '/activity/enablepointbooster'
                        }).then(data => {
                            openMessage('success', '启用成功')
                        }).catch(e => {
                            if (e.code === "ACTIVITY_NOT_FOUND") {
                                openMessage("error", '请前往【积分福利】—— 【积分设置】进行积分规则设置后再编辑多倍积分活动')
                            } else {
                                openMessage("error", e.message)
                            }
                        })
                        break
                    case 'disable':
                        await $fetch.post({
                            url: '/activity/disablepointbooster'
                        }).then(data => {
                            openMessage('success', '停用成功')
                        }).catch(e => {
                            if (e.code === "ACTIVITY_NOT_FOUND") {
                                openMessage("error", '请前往【积分福利】—— 【积分设置】进行积分规则设置后再编辑多倍积分活动')
                            } else {
                                openMessage("error", e.message)
                            }
                        })
                        break
                    default:
                        break
                }
            } catch (e) {
                openMessage('error', e.message || '修改状态失败')
            }
        }

        function openPointsMagnificationSetting() {
            (ctx.refs.pointsMagnificationSetting as any).open()
        }

        return {
            // data
            mode,
            isShowMemberSlider,
            curDiscountActivity,
            pointBoosterActivity,
            memberDiscountActivitys,
            discountObjectMap,
            statusMap,
            weekDayMap,
            isLoading,
            // methods
            fixNumPro,
            createDiscount,
            updateDiscount,
            elSwitchChange,
            getMemberDiscountActivity,
            getPointBoosterActivity,
            openPointsMagnificationSetting,
            openMemberDiscountSetting,
            memberDayDiscountSwitch,
            onPointBoosterSwitchChange,
            pointBoosterActivitySwitch
        }
    },
    components: {
        MemberDaySlider,
        MySwitch,
        DateEllipsis,
        PointsMagnificationSetting,
        MemberDiscountSetting
    }
})
</script>

<style lang="scss" scoped>
.card {
    display: flex;
    padding: 19px 12px;
    margin-top: 12px;
    height: 100px;
    width: 252px;
    background: #F7F7F7;
    border-radius: 10px;
    user-select: none;
    cursor: pointer;

    &:active {
        background-color: #f0f0f0;
    }

    & + .card {
        margin-left: 19px;
    }

    .left {
        .title {
            display: flex;
            i {
                display: block;
                height: 16px;
                width: 4px;
                border-radius: 2px;
                background: #333;
                margin-right: 8px;
            }

            span {
                color: #333;
                font-size: 14;
                font-weight: bold;
            }
        }

        .info {
            margin-top: 10px;
            color: #999;
            font-size: 12px;
            line-height: 16px;
        }
    }

    .right {
        display: flex;
        flex: 1;
        margin-right: 9px;
        align-items: center;
        justify-content: flex-end;
    }

    
}

.member-background {
    background-image: url("~@/assets/images/a1.png");
    background-size: auto 80px;
    background-position: bottom right;
    background-repeat: no-repeat;
}

.points-background {
    background-image: url("~@/assets/images/a3.png");
    background-size: auto 80px;
    background-position: bottom right;
    background-repeat: no-repeat;
}
</style>
